import { render, staticRenderFns } from "./amount-with-currency.vue?vue&type=template&id=3e6ca657&scoped=true"
import script from "./amount-with-currency.vue?vue&type=script&lang=ts"
export * from "./amount-with-currency.vue?vue&type=script&lang=ts"
import style0 from "./amount-with-currency.vue?vue&type=style&index=0&id=3e6ca657&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e6ca657",
  null
  
)

export default component.exports